import Cookies from 'js-cookie'
import config from '../config'

export const TOKEN_KEY = 'access_token'

export const setToken = (token) => {
  console.log('setToken',token)
  Cookies.set(TOKEN_KEY, token, {
    expires: config.cookieExpires || 1
  })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return ''
}

/**
 * 清空所有cookie中的值
 */
export const removeCookies = () => {
  const cookies = document.cookie.split(';')

  if (cookies.length > 0) {
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      setCookie({ name: name.trim(), value: '' })
    }
  }
}

export const setCookie = (options) => {
  Cookies.set(options.name, options.value, {
    expires: config.cookieExpires || 1
  })
}

export const getCookie = (name) => {
  const options = Cookies.get(name)
  if (options) return options
  else return ''
}



// WEBPACK FOOTER //
// ./src/libs/auth.js